import BannerEn from "@assets/translate_banner/Banner_EN.svg";
import BannerTm from "@assets/translate_banner/Banner_TM.svg";
import BannerUnitEn from "@assets/translate_banner/Banner_Unit_EN.svg";
import BannerUnitTm from "@assets/translate_banner/Banner_Unit_TM.svg";
import Image from "@elements/ResponsiveImage/Image";
import { useEffect, useState } from "react";
import { Link } from "react-router";
import { twMerge } from "tailwind-merge";

export type TranslateBannerProps = {
  className?: string;
  mobileView?: boolean;
};

export default function TranslateBanner({
  className,
  mobileView = false,
}: TranslateBannerProps) {
  const [imageTm, setTmageTm] = useState(false);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTmageTm(!imageTm);
    }, 3000);

    return () => {
      clearInterval(intervalId);
    };
  }, [imageTm]);

  return (
    <div className={className}>
      <Link
        to="/tamil-translation-service-singapore"
        target="_blank"
        rel="noopener noreferrer"
      >
        {mobileView ? (
          <>
            <Image
              src={BannerUnitEn}
              alt={"Translation Banner"}
              className={twMerge(
                "w-full !object-contain !aspect-auto",
                !imageTm && "hidden",
              )}
              srcWidth={100}
              srcHeight={100}
            />
            <Image
              src={BannerUnitTm}
              alt={"Translation Banner"}
              className={twMerge(
                "w-full !object-contain !aspect-auto",
                imageTm && "hidden",
              )}
              srcWidth={100}
              srcHeight={100}
            />
          </>
        ) : (
          <>
            <Image
              src={BannerEn}
              alt={"Translation Banner"}
              className={twMerge(
                "w-full !object-contain !aspect-auto",
                !imageTm && "hidden",
              )}
              srcWidth={100}
              srcHeight={100}
            />
            <Image
              src={BannerTm}
              alt={"Translation Banner"}
              className={twMerge(
                "w-full !object-contain !aspect-auto",
                imageTm && "hidden",
              )}
              srcWidth={100}
              srcHeight={100}
            />
          </>
        )}
      </Link>
    </div>
  );
}
